import { render, staticRenderFns } from "./GoModules.vue?vue&type=template&id=0b2d1c1f&"
import script from "./GoModules.vue?vue&type=script&lang=js&"
export * from "./GoModules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b2d1c1f')) {
      api.createRecord('0b2d1c1f', component.options)
    } else {
      api.reload('0b2d1c1f', component.options)
    }
    module.hot.accept("./GoModules.vue?vue&type=template&id=0b2d1c1f&", function () {
      api.rerender('0b2d1c1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/repositories/GoModules.vue"
export default component.exports